import React from "react";
import { FaBriefcase, FaRulerCombined, FaBuilding, FaParking, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function OfficeDetails({ product }) {
    if (!product) return <p className="productspec-error">Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Ad", value: product.name, icon: <FaBriefcase /> },
        { label: "Qiymət", value: product.price ? `${product.price} AZN` : null },
        { label: "Şəhər", value: product.city },
        { label: "Kateqoriya", value: product.categoryName },
        { label: "Sub-kateqoriya", value: product.subCategoryName },
        { label: "Əmlak növü", value: product.propertyType },
        { label: "Ümumi sahə", value: product.totalArea ? `${product.totalArea} m²` : null, icon: <FaRulerCombined /> },
        { label: "Otaq sayı", value: product.roomCount ? `${product.roomCount} otaq` : null },
        { label: "Mərtəbə", value: product.floorNumber ? `${product.floorNumber}-ci mərtəbə` : null, icon: <FaBuilding /> },
        { label: "İstilik sistemi", value: product.heatingSystem },
        { label: "Kommunikasiya", value: product.communicationList?.length > 0 ? product.communicationList.join(", ") : null },
        { label: "Sənəd Statusu", value: product.documentStatus },
        { label: "Əşyalı", value: getStatus(product.isFurnished), status: product.isFurnished },
        { label: "Park yeri", value: getStatus(product.hasParking), status: product.hasParking, icon: <FaParking /> },
        { label: "Siqnalizasiya sistemi", value: getStatus(product.hasAlarmSystem), status: product.hasAlarmSystem },
        { label: "Kamera müşahidəsi", value: getStatus(product.hasCameraSystem), status: product.hasCameraSystem },
        { label: "İnternet", value: getStatus(product.hasInternet), status: product.hasInternet },
        { label: "Kondisioner", value: getStatus(product.hasAirConditioner), status: product.hasAirConditioner },
        { label: "Sanitar qovşağı", value: getStatus(product.hasWC), status: product.hasWC },
        { label: "Qaz", value: getStatus(product.hasGas), status: product.hasGas },
        { label: "Su", value: getStatus(product.hasWater), status: product.hasWater },
        { label: "Elektrik", value: getStatus(product.hasElectricity), status: product.hasElectricity },
        { label: "Təyinat", value: product.suitableFor },
        { label: "Elan tarixi", value: product.createdAt ? new Date(product.createdAt).toLocaleString("az-Latn-AZ") : null },
        { label: "Bitmə tarixi", value: product.endDate ? new Date(product.endDate).toLocaleString("az-Latn-AZ") : null }
    ];

    return (
        <div className="productspec-container productspec-container--realestate">
            <div className="productspec-header">
                <FaBriefcase className="productspec-header__icon" />
                <h3 className="productspec-header__title">Ofis Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--neutral') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--neutral" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default OfficeDetails;